import type { EstimationItemForCalculation } from './model';

export class EstimationCalculatorValidator {
  public static checkInvalidItems(estimationItems: EstimationItemForCalculation[]) {
    const invalidEstimationItems = estimationItems.filter((item) => item.id === item.parentId);

    if (invalidEstimationItems.length > 0) {
      throw new Error(
        `Invalid estimation items (ID <-> PARENT_ID match): ${JSON.stringify(invalidEstimationItems)};`,
      );
    }
  }

  public static checkEndlessLoop(
    estimationItem: EstimationItemForCalculation,
    estimationItems: EstimationItemForCalculation[],
    recursiveVisits: Set<string>,
  ) {
    if (recursiveVisits.has([estimationItem.id, estimationItem.parentId].join('-'))) {
      const items = JSON.stringify(estimationItems);
      throw Error(
        `Invalid estimation items (ID <-> PARENT_ID <-> ID: endless loop detected): ${items}`,
      );
    }
  }
}
